import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { isAccessPermitted } from '../../utils';

const RestrictComponent = ({ children, ...props }) => (isAccessPermitted(props) ? children : null);

const mapStateToPros = state => ({
  userRole: state.user.currentUser.role,
  isGlobalAdmin: state.user.currentUser.isGlobalAdmin
  // emailVerified: state.user.currentUser.emailVerified
});

RestrictComponent.propTypes = {
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
  roles: PropTypes.oneOfType([PropTypes.array, PropTypes.string]),
  excludeRoles: PropTypes.oneOfType([PropTypes.array, PropTypes.string]),
  userRole: PropTypes.string,
  emailVerified: PropTypes.bool,
  isGlobalAdmin: PropTypes.bool
};

export default connect(mapStateToPros)(RestrictComponent);
